import React, { useState } from 'react';
import { DialogInput, RequiredDialogInput, handleInputChange } from '../DialogInputs';
import CommonConfigDialog from './CommonConfigDialog';
import SiteOrBusinessUnitSelect from '../SiteOrBusinessUnitSelect';
import { useSaveQIRStatus, useDeleteQIRStatus } from '../../../../hooks/useQIRStatus';

function QIRStatusEditDialog({ dialogData, setDialogData, showDialog, closeDialog }) {
    const [fieldErrors, setFieldErrors] = useState({});
    const { saveQIRStatus } = useSaveQIRStatus();
    const { deleteFunction } = useDeleteQIRStatus(dialogData);

    const onChange = (e) => {
        handleInputChange(e, dialogData, setDialogData, fieldErrors, setFieldErrors);
    };

    return (
        <CommonConfigDialog title={"Status - " + dialogData.name} dialogData={dialogData} showDialog={showDialog} closeDialog={closeDialog} save={saveQIRStatus} canDelete deleteFunction={deleteFunction} fieldErrors={fieldErrors} setFieldErrors={setFieldErrors} >
            <RequiredDialogInput controlId="formStatusName" title="Name" placeholder="Name" name="name" value={dialogData.name} error={fieldErrors.name} onChange={onChange} />
            <SiteOrBusinessUnitSelect controlIdPrefix="AffectedArea" dialogData={dialogData} setDialogData={setDialogData} fieldErrors={fieldErrors} />
            <DialogInput controlId="formAffectedAreaDisplay" title="Display" placeholder="Display" name="display" value={dialogData.display} error={fieldErrors.display} onChange={onChange} />
            <DialogInput controlId="formAffectedAreaTranslationKey" title="Translation Key" placeholder="Translation.Key" name="translationKey" value={dialogData.translationKey} error={fieldErrors.translationKey} onChange={onChange} />
        </CommonConfigDialog>
    );
}

export default QIRStatusEditDialog;